import Vue from 'vue';
import axios from 'axios';

import Constants from '../assets/ts/configuration/Constants';
import Interceptor from '@/assets/ts/utils/Interceptor';
import LoginController from '@/assets/ts/controller/LoginController';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

// Headers list
const requestHeaders = {
  oAuthToken: 'OAuth-Token',
};

// Default header for requests
if (localStorage.TOKEN) {
  axios.defaults.headers.common[requestHeaders.oAuthToken] = localStorage.TOKEN;
}

// Security and redirection on requests
Interceptor.addRequestSuccess((axiosConfig) => {
  const token = localStorage.TOKEN;
  if (token) {
    axiosConfig.headers[requestHeaders.oAuthToken] = token;
  }
  
  return axiosConfig;
});


Interceptor.addResponseFail((axiosError) => {
  if (!axios.isCancel(axiosError)) {
    const response = axiosError.response;
    if (response && response.data) {
      const { error, errorCode } = response.data;
      if (errorCode === 403) {
        SnackbarUtils.showMessage('Sessão expirada. Redirecionando para o login.', SnackbarUtils.TYPE_ALERT);
        LoginController.redirectToLogin();
      } else if (error) {
        // Tratativa padrão de erros na requisição
      }
    } else {
      console.error('Erro na resposta: ', axiosError.message);
      throw axiosError;
    }
  }

  return Promise.reject(axiosError);
});
